<template>
  <!-- 添加安全检查，确保extras1和formBgWap存在 -->
  <div
    v-if="extras1 && extras1.formBgWap"
    class="banner-new"
    :style="{
      background:
        extras1.formBgWap && extras1.formBgWap.colorOrBg == 'color'
          ? extras.formBgWap.color
          : '',
    }"
  >
    <!-- 添加安全检查 -->
    <img
      :src="
        extras1.formBgWap && extras1.formBgWap.colorOrBg == 'src'
          ? extras.formBgWap.src
          : ''
      "
      alt=""
    />

    <div v-if="isSetting != 1">
      <!-- 添加完整的安全检查链 -->
      <div class="seminar-info">
        <!-- 检查BannerText是否存在 -->
        <div
          class="seminar-info-new wap"
          :class="extras1.BannerText && extras1.BannerText.textAlign"
        >
          <div class="content">
            <!-- 为textSetting的所有访问添加安全检查 -->
            <div
              class="seminar-title"
              v-if="
                extras1.textSetting && extras1.textSetting.subTitle != 'hide'
              "
              :style="{
                color:
                  extras1.textSetting.subTitle == 'custom'
                    ? extras1.textSetting.subTitleFontColor
                    : '',

                'font-weight':
                  extras1.textSetting.subTitle == 'custom'
                    ? extras1.textSetting.subTitleFontWeight == 'on'
                      ? '900'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.subTitle == 'custom'
                    ? extras1.textSetting.subTitleFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
              }"
            >
              {{ extras1.textSetting && extras1.textSetting.text }}
            </div>

            <div
              class="seminar-slogan"
              v-if="extras1.textSetting && extras1.textSetting.title != 'hide'"
              :style="{
                color:
                  extras1.textSetting.title == 'custom'
                    ? extras1.textSetting.titleFontColor
                    : '',

                'font-weight':
                  extras1.textSetting.title == 'custom'
                    ? extras1.textSetting.titleFontWeight == 'on'
                      ? '900'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.title == 'custom'
                    ? extras1.textSetting.titleFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
              }"
            >
              {{
                extras1.textSetting && extras1.textSetting.title == "default"
                  ? seminarInfo.title
                  : seminarInfo.title
              }}
            </div>

            <div class="semianr-time">
              <div
                class="_title"
                v-show="
                  extras1.textSetting && extras1.textSetting.timeTitle != 'hide'
                "
                :style="{
                  color:
                    extras1.textSetting.timeTitle == 'custom'
                      ? extras1.textSetting.timeTitleFontColor
                      : '',

                  'font-weight':
                    extras1.textSetting.timeTitle == 'custom'
                      ? extras1.textSetting.timeTitleFontWeight == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                  'font-style':
                    extras1.textSetting.timeTitle == 'custom'
                      ? extras1.textSetting.timeTitleFontTilt == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'background-color':
                    extras1.textSetting && extras1.textSetting.titleBgColor
                      ? extras1.textSetting.titleBgColor
                      : 'transparent',
                }"
              >
                {{ getTimeTitleText() }}
              </div>
              <div
                class="_time"
                v-show="
                  extras1.textSetting && extras1.textSetting.time != 'hide'
                "
                :style="{
                  color:
                    extras1.textSetting.time == 'custom'
                      ? extras1.textSetting.timeFontColor
                      : '',

                  'font-weight':
                    extras1.textSetting.time == 'custom'
                      ? extras1.textSetting.timeFontWeight == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                  'font-style':
                    extras1.textSetting.time == 'custom'
                      ? extras1.textSetting.timeFontTilt == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'background-color':
                    extras1.textSetting && extras1.textSetting.timeBgColor
                      ? extras1.textSetting.timeBgColor
                      : 'transparent',
                }"
              >
                {{
                  handleTimeStamps(seminarInfo.startTime, seminarInfo.endTime)
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 设置模式下的内容也需要添加安全检查 -->
    <div v-if="isSetting == 1">
      <div
        class="seminar-info"
        v-if="
          extras1 && extras1.seminarInfo && extras1.seminarInfo.display == '1'
        "
      >
        <div class="seminar-info-new wap _left">
          <div class="content">
            <div class="seminar-title">会议副标题会议副标题</div>
            <div class="seminar-slogan">会议标会议标题</div>
            <div class="semianr-time">
              <div class="_title">会议时间</div>
              <div class="_time">2023-12-12 12:22-24:00</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { isSetting } from "../common/sbase";
export default {
  name: "Banner",
  computed: {
    extras() {
      return this.$store.state.extras;
    },
    extras1() {
      return this.extras;
    },
  },
  data() {
    return {
      isSetting: isSetting,
    };
  },
  props: ["seminarInfo"],
  methods: {
    getTimeText() {
      const config = this.extras1.textSetting;
      return config.timeText
        ? config.timeText
        : this.handleTimeStamps(
            this.seminarInfo.startTime,
            this.seminarInfo.endTime
          );
    },
    getTimeTitleText() {
      const config = this.extras1.textSetting;
      return (
        config.timeTitleText || config.text3 || this.$t("success.meetingTime")
      );
    },
    handleTimeStampToDateTime(timeStamp, format) {
      var lang = (window.$sk && window.$sk.$lang) || "zh_CN";
      var locale = "zh-cn";
      if (lang === "en_US") locale = "en";
      else if (lang === "zh_TW") locale = "zh-tw";
      return moment(timeStamp).locale(locale).format(format);
    },
    handleTimeStamps(startTimeStamp, endTimeStamp) {
      var lang = (window.$sk && window.$sk.$lang) || "zh_CN";
      var fullFmt, dateFmt, shortDateFmt;
      if (lang === "en_US") {
        fullFmt = "MMM DD, YYYY HH:mm";
        dateFmt = "MMM DD, YYYY";
        shortDateFmt = "MMM DD";
      } else if (lang === "zh_TW") {
        fullFmt = "YYYY年MM月DD日 HH:mm";
        dateFmt = "YYYY年MM月DD日";
        shortDateFmt = "MM月DD日";
      } else {
        fullFmt = "YYYY年MM月DD日 HH:mm";
        dateFmt = "YYYY年MM月DD日";
        shortDateFmt = "MM月DD日";
      }
      let startTimeYear = this.handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY"
      );
      let endTimeYear = this.handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY"
      );
      let startDate = this.handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      let endDate = this.handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      if (startDate == endDate) {
        return (
          this.handleTimeStampToDateTime(startTimeStamp * 1000, fullFmt) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, "HH:mm")
        );
      } else if (startTimeYear == endTimeYear) {
        return (
          this.handleTimeStampToDateTime(startTimeStamp * 1000, dateFmt) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, shortDateFmt)
        );
      } else {
        return (
          this.handleTimeStampToDateTime(startTimeStamp * 1000, dateFmt) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, dateFmt)
        );
      }
    },
  },
};
</script>
